import * as Yup from 'yup';

export const memberLoginValidationSchema = Yup.object().shape({
	contentId: Yup.string().required('value required'),
	userName: Yup.string().required('value required'),
	password: Yup.string().required('value required'),
	rememberMe: Yup.bool().required('value required'),
	membershipFieldValue: Yup.string().required('value required')
});
